import { useRouteChangeEvent } from "@circle-react/hooks/utils/useRouteChangeEvent";

export interface RouteChangeEventWrapperProps {
  children: React.ReactNode;
}

export const RouteChangeEventWrapper = ({
  children,
}: RouteChangeEventWrapperProps) => {
  useRouteChangeEvent();
  return <>{children}</>;
};
